export const FAVOURITE_MOVE = 'FAVOURITE_MOVE';
export const FAVOURITE_ADD = 'FAVOURITE_ADD';
export const FAVOURITE_REMOVE = 'FAVOURITE_REMOVE';
export const FAVOURITE_SELECT = 'FAVOURITE_SELECT';
export const FAVOURITE_SET_OFFER_ID = 'FAVOURITE_SET_OFFER_ID';

export function favouriteSetOfferId(offerId) {
    return {
        type: FAVOURITE_SET_OFFER_ID,
        payload: {offerId}
    }
}

export function favouriteMove(moveOf) {
    return {
        type: FAVOURITE_MOVE,
        payload: {moveOf}
    }
}

export function favouriteAdd(id) {
    return {
        type: FAVOURITE_ADD,
        payload: {id}
    }
}

export function favouriteRemove() {
    return {
        type: FAVOURITE_REMOVE
    }
}

export function favouriteSelect(index) {
    return {
        type: FAVOURITE_SELECT,
        payload: {index}
    }
}



// WEBPACK FOOTER //
// ./src/common/menu/favourite/actions.js